import { LinkButton } from '../ui/link-button';

export const ContactUsForMoreDetails = () => {
  return (
    <div className='personalContent mx-auto px-3 pb-[40px] lg_px-0 lg_pb-[80px]'>
      <h2
        id='contact-us'
        className='mb-[10px] font-teko-medium text-[28px] uppercase leading-[30px] lg_mb-[20px] lg_text-[40px] lg_leading-[40px]'
      >
        Contact Us for More Details
      </h2>
      <p className='mb-[20px] font-roboto-regular text-[16px] font-light leading-[24px] lg_mb-[40px] lg_text-[18px] lg_leading-[30px]'>
        We’re here to help with any questions or warranty concerns. Don’t hesitate to reach out—our customer service
        team is always happy to help!
      </p>

      <div className=''>
        <LinkButton
          href='/contact-us'
          className='duration-300 h-[40px] w-full rounded-full bg-black font-roboto-medium text-[16px] leading-[40px] text-white transition-colors hover_bg-[#4C4C4C] lg_h-[50px] lg_w-[140px] lg_text-[18px] lg_leading-[50px]'
        >
          Contact Us
        </LinkButton>
      </div>
    </div>
  );
};
